// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkOrderItem, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import { VariableTrackingModal } from 'components/Mantine/Modals/VariableTrackingModal';

type Props = {
  workOrderItem: WorkOrderItem | null;
  onDeleted: () => void;
  onClose: () => void;
};

export const DeleteWorkOrderItem = ({ workOrderItem: deletingItem, onDeleted, onClose }: Props) => {
  const { apiCall: deleteItemApiCall } = useEvolveDelete(`shop/workOrder/item/:workOrderItemId`);

  return (
    <VariableTrackingModal
      title="Delete work order item"
      variable={deletingItem}
      onConfirm={async (item) => {
        await deleteItemApiCall({ url: `shop/workOrder/item/${item.workOrderItemId}` });
        onDeleted();
      }}
      onClose={onClose}
      confirmationText="Delete"
    >
      {(item) => (
        <Text>
          Are you sure you want to delete item <b>{item.name}</b>?
        </Text>
      )}
    </VariableTrackingModal>
  );
};
